import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { useSoundPacks } from '../context/SoundPacksContext';
import { DatabaseUserModel } from '../services/DatabaseUser';
import { FullPagePreloader } from './ui/Preloader';

// Deep link that mirrors /buy/:packId, but instead of jumping to Stripe it drops
// the pack into the cart and lands the user on /cart. Used from the marketing
// site's "Add to cart" buttons. Logged out, AuthGate takes over first and the
// add happens once the session resolves (the URL is preserved).
function AddToCartPage() {
    const { packId } = useParams<{ packId: string }>();
    const { user } = useUser();
    const { soundPacks, isLoading: packsLoading } = useSoundPacks();
    const navigate = useNavigate();

    useEffect(() => {
        if (packsLoading || !packId || !user) return;

        const pack = soundPacks.find(p => p.id === packId);
        if (!pack?.priceId) {
            console.error('Pack not found or has no priceId:', packId);
            navigate('/cart', { replace: true });
            return;
        }

        DatabaseUserModel.addToCart(user.uid, packId)
            .catch(error => console.error('Failed to add pack to cart:', error))
            .finally(() => navigate('/cart', { replace: true }));
    }, [packId, user, soundPacks, packsLoading, navigate]);

    return <FullPagePreloader />;
}

export default AddToCartPage;
